// src/components/routes/RouteForm.jsx
import React, { useEffect, useState } from "react";
import {
    Form, FormGroup, Label, Input, Row, Col, Button, FormFeedback
} from "reactstrap";
import * as dayjs from 'dayjs';
import Session from '../auth/Session';

const FuelRateForm = ({ fuelRateItem, apiBaseUrl, onSuccess, onCancel }) => {
    const [errors, setErrors] = useState({});

    const [formData, setFormData] = useState(fuelRateItem || {
        id: 0,
        state: "",
        monthYear: "",
        rate: ""
    });

    useEffect(() => {
        console.log('fule rate')
        console.log(fuelRateItem);
        if (fuelRateItem) {
            setFormData({
                id: fuelRateItem.id,
                state: fuelRateItem.state ?? "",
                monthYear: fuelRateItem.monthYear ?? "",
                rate: fuelRateItem.rate ?? ""
            });
        }
    }, [fuelRateItem]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(p => ({ ...p, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const method = fuelRateItem ? "PUT" : "POST";
        const url = fuelRateItem
            ? `${apiBaseUrl}/api/fuelrate/${formData.id}`
            : `${apiBaseUrl}/api/fuelrate`;

        let data = {
            ...formData,
            rate: formData.rate === "" ? 0 : Number(formData.rate)
        };

        const token = Session.getToken();
        const response = await fetch(url, {
            method,
            headers: token
                ? { "Content-Type": "application/json", Authorization: `Bearer ${token}` }
                : { "Content-Type": "application/json" },
            body: JSON.stringify(data),
        });

        if (response.ok) onSuccess();
    };

    return (
        <Form onSubmit={handleSubmit}>
            <Row>
                <Col md={6}>
                    <FormGroup>
                        <Label>State</Label>
                        <div>
                            <Label>{fuelRateItem.state}</Label>
                        </div>
                    </FormGroup>
                </Col>
                <Col md={6}>
                    <FormGroup>
                        <Label>Month/Year</Label>
                        <div>
                            <Label>{dayjs(fuelRateItem.monthYear, "YYYY-MM-DD").format('MMM-YYYY')}</Label>
                        </div>
                    </FormGroup>
                </Col>
            </Row>
            <Row>
                <Col md={3}>
                    <FormGroup>
                        <Label>Rate</Label>
                        <Input name="rate" type="number" step="0.01" value={formData.rate} onChange={handleChange} />
                    </FormGroup>
                </Col>
            </Row>
            <div className="d-flex justify-content-end gap-2">
                <Button color="secondary" type="button" onClick={onCancel}>Cancel</Button>
                <Button color="primary" type="submit">{`${formData.id}` !== `0` ? "Update" : "Create"}</Button>
            </div>
        </Form>
    );
};

export default FuelRateForm;
